import { render, staticRenderFns } from "./ForumListItem.vue?vue&type=template&id=72d15056&scoped=true"
import script from "./ForumListItem.vue?vue&type=script&lang=ts"
export * from "./ForumListItem.vue?vue&type=script&lang=ts"
import style0 from "./ForumListItem.vue?vue&type=style&index=0&id=72d15056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d15056",
  null
  
)

export default component.exports